import { useState } from "react";
import { Plus, X } from "lucide-react";
import { toast } from "sonner";

function favicon(url) {
  try {
    const host = new URL(url).hostname;
    return `https://www.google.com/s2/favicons?domain=${host}&sz=64`;
  } catch {
    return null;
  }
}

function hostLabel(url) {
  try { return new URL(url).hostname.replace("www.", ""); } catch { return url; }
}

export default function BookmarkCard({ card, onData }) {
  const d = card.data || {};
  const links = d.links || [];
  const [adding, setAdding] = useState(false);
  const [title, setTitle] = useState("");
  const [url, setUrl] = useState("");

  const addLink = () => {
    let u = url.trim();
    if (!u) return;
    if (!/^https?:\/\//i.test(u)) u = `https://${u}`;
    if (!favicon(u)) { toast.error("Invalid URL"); return; }
    onData({ links: [...links, { title: title.trim() || hostLabel(u), url: u }] });
    setTitle(""); setUrl(""); setAdding(false);
  };

  return (
    <div className="space-y-2">
      <div className="grid grid-cols-4 gap-2">
        {links.map((l, i) => (
          <div key={i} className="group relative">
            <a href={l.url} target="_blank" rel="noopener noreferrer" data-testid={`bookmark-link-${i}`}
              className="flex flex-col items-center gap-1 rounded-xl bg-white/50 dark:bg-black/25 p-2 transition-transform hover:scale-105">
              <img src={favicon(l.url)} alt={l.title} className="h-8 w-8 rounded-lg" />
              <span className="w-full truncate text-center text-[10px] font-medium">{l.title}</span>
            </a>
            <button
              data-testid={`bookmark-remove-${i}`}
              onClick={() => onData({ links: links.filter((_, j) => j !== i) })}
              className="absolute -right-1 -top-1 hidden h-4 w-4 items-center justify-center rounded-full bg-red-500 text-white group-hover:flex">
              <X className="h-2.5 w-2.5" />
            </button>
          </div>
        ))}
        <button data-testid="bookmark-add-button" onClick={() => setAdding(!adding)}
          className="flex h-full min-h-[60px] flex-col items-center justify-center gap-1 rounded-xl border-2 border-dashed border-current/30 opacity-50 transition-opacity hover:opacity-90">
          <Plus className="h-5 w-5" />
        </button>
      </div>
      {adding && (
        <div className="space-y-1.5 rounded-xl bg-black/10 dark:bg-white/10 p-2">
          <input data-testid="bookmark-title-input" value={title} onChange={(e) => setTitle(e.target.value)}
            placeholder="Label (optional)"
            className="w-full rounded-lg bg-white/60 dark:bg-black/30 px-2 py-1.5 text-xs outline-none" />
          <input data-testid="bookmark-url-input" value={url} onChange={(e) => setUrl(e.target.value)}
            onKeyDown={(e) => e.key === "Enter" && addLink()}
            placeholder="https://..."
            className="w-full rounded-lg bg-white/60 dark:bg-black/30 px-2 py-1.5 text-xs outline-none" />
          <button data-testid="bookmark-save-button" onClick={addLink}
            className="w-full rounded-lg bg-violet-500 py-1.5 text-xs font-bold text-white">Add link ✦</button>
        </div>
      )}
      {links.length === 0 && !adding && (
        <p className="text-center font-hand text-lg opacity-50">pin your fav links here</p>
      )}
    </div>
  );
}
